import React, { useContext } from "react";

import ImageCopyright from "@/components/ImageCopyright/ImageCopyright";
import { Overlay } from "@/components/Overlay";
import { GlobalContext } from "@/contexts";
import { LocaleProps, withLocale } from "@/i18n";
import { ImageData } from "@/service/Model";

import { ImageCopyrightWrapper, Scroll } from "./styles";

export type CopyrightOverlayProps = {
  onClose: () => void;
  imagesData: ImageData[];
} & LocaleProps;

const CopyrightOverlay: React.FC<CopyrightOverlayProps> = (
  props: CopyrightOverlayProps
): JSX.Element => {
  const { onClose, imagesData, i18n } = props;
  const globalContext = useContext(GlobalContext);

  return (
    <Overlay
      icons={globalContext.icons}
      dismiss={true}
      showCloseButton={true}
      onClose={onClose}
    >
      <ImageCopyrightWrapper>
        <h2>{i18n?.imageCopyright}</h2>
        <Scroll>
          {imagesData.map((imageData: ImageData, index: number) => (
            <ImageCopyright
              sourceLabel={i18n?.source}
              imageData={imageData}
              key={`ìmage-${index}`}
            />
          ))}
        </Scroll>
      </ImageCopyrightWrapper>
    </Overlay>
  );
};

export default withLocale(CopyrightOverlay);
